import HTTPRequest from '../index'

const apiPathSelectedPlan = 'api/v2/users/plans/selected-from-lp'

class SelectedPlan extends HTTPRequest {
  getSelectedPlan(params: Record<string, any> | URLSearchParams) {
    if (params instanceof URLSearchParams) {
      return this.get(`${apiPathSelectedPlan}?${params.toString()}`)
    }

    return this.get(`${apiPathSelectedPlan}`, { params })
  }
}

export default new SelectedPlan()
